if (!customElements.get("funky-img-accordion")) {
	customElements.define(
		"funky-img-accordion",
		class FunkyImgAccordion extends HTMLElement {
			constructor() {
				super();
				this.initDetails();
			}

			initDetails() {
				var expand = this.querySelector(".item-expand");
				var faqs = this.querySelectorAll(".details");
				faqs.forEach((faq) => {
					faq.addEventListener("click", function () {
						faq.classList.toggle("active");
					});
				});
				expand.addEventListener("click", function (event) {
					faqs.forEach((faq) => {
						faq.classList.add("active");
					});
				});
			}

			renderSection(url) {
				fetch(`${url}?section_id=${this.dataset.section}`)
					.then((response) => response.text())
					.then((responseText) => {
						const html = new DOMParser().parseFromString(
							responseText,
							"text/html"
						);
						const destination =
							document.getElementById("FunckyContent");
						const source = html.getElementById("FunckyContent");
						if (source && destination) {
							destination.innerHTML = source.innerHTML;
							this.initDetails();
						}
					});
			}
		}
	);
}
